import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
// @ts-ignore
import VueApexCharts from 'vue-apexcharts';
import ChartHeader from '@/modules/Statistics/components/ChartHeader.vue';
import { DashboardReportFields } from '@/modules/Statistics/interfaces/DashboardReport';
import { formatValueForDashboard } from '@/helpers/NumberFormatter';

interface Props {
    data: DashboardReportFields;
    isEdit: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Chart',
  props: {
    data: null,
    isEdit: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    data: DashboardReportFields;
    isEdit: boolean;
};

const chart = VueApexCharts;



const chartWidth = ref('100%');
const series = ref<null | Array<{ name: string; data: number[] }>>(null);
const options = ref<any>(null);

const chartHeight = computed(() => {
    switch (props.data.size) {
        case 'L':
            return '200%';
        case 'M':
            return '150%';
        default:
            return '130%';
    }
});

const axisTextFontSize = computed(() => {
    switch (props.data.size) {
        case 'L':
            return '14px';
        case 'M':
            return '13px';
        default:
            return '10px';
    }
});

const chartSize = computed(() => {
    switch (props.data.size) {
        case 'S':
            return {
                width: '48%',
                height: '48%',
            };
        default:
            return {
                width: '100%',
                height: '100%',
            };
    }
});

function changeChartSize(size: 'S' | 'M' | 'L') {
    props.data.size = size;
}

function updateChart(data: any) {
    options.value = {
        chart: {
            type: 'bar',
            toolbar: {
                show: false,
            },
            events: {
                mounted: (chartInstance: any) => {
                    chartInstance.windowResizeHandler();
                },
            },
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                horizontal: data.statisticReport.data.fields[1].name === 'Y axis' ? false : true,
            },
        },
        xaxis: {
            categories: data.statisticReport.data.values.map((item: any) => item[0]),
            labels: {
                rotate: -35,
                trim: false,
                hideOverlappingLabels: false,
                style: {
                    colors: [],
                    fontSize: axisTextFontSize.value,
                    fontWeight: 400,
                    cssClass: 'chart-label',
                    maxWidth: '1rem',
                },
            },
        },
        dataLabels: {
            enabled: false,
            formatter: (val: number) => {
                return formatValueForDashboard(val);
            },
        },
        yaxis: {
            // max: 50,
            // tickAmount: 5,
            logarithmic: true,
            forceNiceScale: true,
            labels: {
                formatter: (val: number) => {
                    if (typeof val === 'number') {
                        return formatValueForDashboard(val);
                    } else {
                        return val;
                    }
                },
                style: {
                    fontSize: axisTextFontSize.value,
                },
            },
        },
        crosshairs: {
            show: true,
            position: 'back',
            stroke: {
                color: '#b6b6b6',
                width: 1,
                dashArray: 0,
            },
        },
    };

    series.value = [
        {
            name: data.statisticReport.data.fields[2].name,
            data: data.statisticReport.data.values.map((item: any) => item[1]),
        },
    ];
}

watch(
    () => props.data,
    (newChartData: any) => {
        if (newChartData.statisticReport.data.fields.length) {
            updateChart(newChartData);
        }
    },
    { deep: true, immediate: true },
);

return { __sfc: true,chart, props, chartWidth, series, options, chartHeight, axisTextFontSize, chartSize, changeChartSize, updateChart, ChartHeader }
}

})